<template>
     <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Create Task</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Task</li>
            </ol>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
 
    
    <section class="content">
      <div class="container-fluid">
      
         <!-- /.card -->
         <div class="card">
          <div class="card-header">
            <h3 class="card-title">Task List</h3>

            <div class="card-tools">
              <button type="button" class="btn btn-success" data-toggle="modal" data-target="#modal-default-addDepart">Add Task</button>            
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row" style="height: 638px;overflow: scroll;">
              <table id="tableComponent" class="table table-bordered table-striped">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Task Title</th>
                    <th>Goal</th>
                    <th>Assign User</th>
                    <th>Due Date</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index)  in fetchUserwiseTasklist" :key="value">
                        <td>{{index+1}}</td>
                        <!-- <td>{{value.userName}}</td> -->
                        <td>{{value.title}}</td>
                        <td>{{value.projectdetails}}</td>
                        <td>{{value.assigndetails}}</td>
                        <td>{{moment(value.duedate)}}</td>
                        <td class="text-center"><button type="button"  data-toggle="modal" data-target="#modal-default"  @click="taskActivity(value.taskid)" style="border: none;color: #28a745;background: none;"><i class="fa fa-pencil-square fa-2x" aria-hidden="true"></i></button></td>

                    </tr>
                   
                  </tbody>
                
                </table>
             
            </div>
            <!-- /.row -->

          </div>
          <!-- /.card-body -->
          <div class="card-footer">
          
          </div>
        </div>
    </div>
    
 </section>
  <!-- Main content -->
   <div class="modal fade" id="modal-default-addDepart">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Add Task</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form v-on:submit.prevent="submitTask"  ref="textareaform">

                <div class="card-body row">
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Title</label>
                            <input type="text" v-model="title" class="form-control" id="title" placeholder="Enter title" required>
                        </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Description</label>
                      <textarea class="form-control" v-model="description" rows="2" id="description" required></textarea>
                    </div>

                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Goal</label>
                      <select
                        v-model="Projectid"
                        class="form-control"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchDepart.projects" :key="valuedept.id" :value="valuedept.id" >{{valuedept.projectName}}</option>
                      </select>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                        <label for="exampleInputEmail1">Entity <span>(optional)</span></label>
                        <select
                        v-model="entity"
                        class="form-control select2bs4"
                        style="width: 100%"
                        >
                        <option v-for="valuedept in fetchEntity" :value="valuedept.id" :key="valuedept.id">{{valuedept.entityname}}</option>
                    
                        </select>
                        </div>
                    </div> -->
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Super Project</label>
                            <select
                        v-model="subproject"
                        class="form-control select2bs4"
                        style="width: 100%"
                        >
                        <option v-for="valuedept in fetchSubproject" :value="valuedept.id" :key="valuedept.id">{{valuedept.projectname}}</option>
                        </select>
                        </div>
                  </div> -->
                  <!-- <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">department</label>
                    
                      <select
                        v-model="department"
                        class="form-control select2bs4"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchDepart.DeptList" :key="valuedept.name">{{valuedept.name}}</option>
                      </select>
                    </div>
                  </div> -->

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Assign Users</label>
                      <Multiselect
                          v-model="user"
                          placeholder="Select Task Assign User"
                          label="name"
                          valueProp="userId"
                          multiplelabel="name"
                          track-by="name"
                          :close-on-select="true"
                          :searchable="true"
                          :options='fetchUsers'>
                        </Multiselect>
                      <!-- <select
                        v-model="user"
                        class="form-control select2bs4"
                        style="width: 100%"
                      >
                       <option v-for="valuedept in fetchUsers" :key="valuedept.name">{{valuedept.name}}</option>
                      </select> -->
                    </div>
                  </div>
                  
                 
                  <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Progress</label>
                            <select v-model="Progress" class="form-control select2bs4" style="width: 100%">
                                    <option value="todo">Todo</option>
                                    <option value="inprogress">Inprogress</option>
                                    <option value="reviews">Reviews</option>
                                    <option value="done">Done</option>
                          </select>
                        </div>
                  </div> -->
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Priority</label>
                            <select v-model="Priority" class="form-control select2bs4" required style="width: 100%">
                                    <option value="Urgent">Urgent</option>
                                    <option value="Important">Important</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                          </select>
                        </div>
                  </div>
                  <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Due Date</label>
                           <input type="date" v-model="Duedate" class="form-control" />
                        </div>
                  </div>
                </div>
                <!-- /.card-body -->

                <div class="card-footer">
                  <button type="submit" class="btn btn-primary">Submit</button>
                </div>
              </form>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" id="close1" class="btn btn-default" data-dismiss="modal"  @click="close">Close</button>

            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <div class="modal fade "  id="modal-default" @close="showModal = false">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title text-uppercase">{{tasktitle}}</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <button class="btn btn-success col-sm-3" @click="updateform">Update</button>
              <p style="float:right">{{description}}</p>
              <form v-if="checklistview" @submit.prevent="submitTaskAcitivity">

                <div class="card-body row">
                 
                 <div class="col-sm-6">
                        <div class="form-group">
                            <label for="exampleInputEmail1">Title</label>
                            <input type="text" v-model="edittasktitle" class="form-control" id="title" placeholder="Enter title" require>
                        </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Description</label>
                      <textarea class="form-control" v-model="editdescription" rows="2" id="description"></textarea>
                    </div>

                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Assign Users</label>
                      
                      <input class="form-control" readonly v-model="Tskassignuser" />
                      <!-- <Multiselect
                          v-model="user"
                          mode="tags"
                          placeholder="Select Task Assign User"
                          label="name"
                          valueProp="name"
                          multiplelabel="name"
                          track-by="name"
                          :close-on-select="false"
                          :searchable="true"
                          :options='fetchUsers'></Multiselect> -->
                    </div>
                  </div>
                  
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="exampleInputEmail1">Created By</label>
                      
                      <input class="form-control" readonly v-model="hod" />

                      
                    </div>
                  </div>
                </div>
              
                <!-- /.card-body -->
                <div class="col-sm-12 ml-3">
                        <input type="submit" class="btn btn-success"/>
                      </div>
              </form>
                
            </div>
            <div class="container">
                    
                    <div class="col-sm-12">

                      <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Check List 
                </h3>

                <div>
                  <span class="ml-4" >{{count}}/{{fetchChecklist.length}}</span>
                  <div class="progress mb-3">
                  <div class="progress-bar bg-success" role="progressbar" aria-valuenow="2" aria-valuemin="0"
                       aria-valuemax="4"  :style="{ width: maincnt + '%' }">
                    <span class="sr-only">40% Complete (success)</span>
                  </div>
                </div>
                </div>
               
              </div>
             
               <!-- /.card-header -->
               <div class="">
                <ul class="todo-list" data-widget="todo-list">
                  <li v-for="val in fetchChecklist" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>
                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">
                       
                        <span v-if="val.status=='true'">
                          <input type="checkbox"  id="todoCheck1{{val.id}}" checked  readonly disabled />
                        </span>
                        <span v-else>
                          <input type="checkbox"  id="todoCheck1{{val.id}}" readonly disabled/>
                        </span>
                        
                      <!-- <input type="checkbox" value="" name="todo1" id="todoCheck1" @click="checkboxclick(this.value)"> -->
                      <label for="todoCheck1{{val.id}}"></label>
                    </div>
                    <!-- todo text -->
                    <span class="text">{{val.checklist1}}</span>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails.name?val.userdetails.name:''}}</b></span>
                      <br/>
                      <!-- <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span> -->
                      
                    </div>
                  </li>

                </ul>
              </div>          
            
            </div>
          </div>
                  
                  

                </div>
                <!-- secod -->

                <div class="container">
                  <div class="col-sm-12">
                   
                  <div class="card">
                    <div class="card-header">
                    <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Action List 
                </h3>
                </div>
                  
            <div class="card-body">
                <ul class="todo-list" data-widget="todo-list">
                  
                  <li v-for="val in getActionListDash" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>

                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">                      
                        <div class="text">{{val.actionlist1}}</div>
                    </div>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails.name?val.userdetails.name:''}}</b></span>
                      <br/>
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span>
                      
                    </div>
                   </li>

                </ul>
              </div>

                  </div>
                 </div>
                </div>

              <div class="container">
                <div class="col-sm-12">

            <div class="card">
              <div class="card-header">
                    <h3 class="card-title">
                  <i class="ion ion-clipboard mr-1"></i>
                  Comments List 
                </h3>
                </div>
               
              <div class="card-body">
                <ul class="todo-list" data-widget="todo-list">
                  
                  <li v-for="val in getCommentsListDash" :key="val">
                    <span class="handle">
                      <i class="fas fa-ellipsis-v"></i>
                      <i class="fas fa-ellipsis-v"></i>
                    </span>

                      <!-- checkbox -->
                      <div  class="icheck-primary d-inline ml-2">                      
                        <div class="text">{{val.commentlist1}}</div>
                    </div>
                    <div class="toolss" >
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Created By: <b>{{val.userdetails?val.userdetails.name:''}}</b></span>
                      <br/>
                      <span class="ml-2" style="float:right;    margin-top: -27px;">Date:<b>{{moment(val.sdaate)}}</b></span>
                      
                    </div>
                   </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
            <div class="modal-footer justify-content-between">
              <button type="button" id="close" class="btn btn-default" data-dismiss="modal"  @click="close">Close</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

</template>
<script>
// import draggable from "vuedraggable";

import { mapGetters,mapActions } from "vuex"
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Multiselect from '@vueform/multiselect'
import axios from 'axios'
import moment from 'moment'

export default {
  data() {
          return {
            Projectid:'',
            department:'',
            hod:'',
            user:null,
            Progress:'',
            Priority:'Low',
            Position:'1',
            Duedate:'',
            title:'',
            value: null,
            entity:'',
            subproject:'',
            description:'',
            checklistview:false,    
            editdescription:'',    
            edittasktitle:'',                   
          }
      },
      components: {
      Multiselect,
    },
      computed: {
    ...mapActions(['getActionListdata','getCheckListdetailsUser','getTaskdetailsUser','getCommentsListdata','ActionUserWiseTaskList','ActionSubProject','ActionEntity','GetUsers','fetchUserType','DeptList','fetchProjects','DepartUser']),
    ...mapGetters(['fetechUserTask','fetchChecklist','getActionListDash','getCommentsListDash','fetchUserwiseTasklist','fetchUsers','fetchDepart','fetchProject','fetchEntity','fetchSubproject','fetchDepartWiseUser','getTaskEmailUser']),

      },
      mounted() {
        this.departmentlist()
      },
      methods:{
        moment: function (date) {
        if(date){
          return moment(date).format('DD-MM-Y');
        }
    },
        submitTaskAcitivity(){
          
          let payload={
                    taskid:this.fetechUserTask.taskid,
                    Projectid:this.fetechUserTask.projectid,
                    Depart:this.fetechUserTask.depart,
                    sdate:null,
                    userName:localStorage.getItem('userID'),
                    title:this.edittasktitle,
                    description:this.editdescription,
                    assign:this.fetechUserTask.assign,
                    Progress:this.fetechUserTask.progress,
                    Priority:this.fetechUserTask.priority,
                    Position:this.fetechUserTask.position,
                    Duedate:this.fetechUserTask.duedate,
                    entyid:this.entyid,
                    sprojectid:''
                }
    
              this.$store.dispatch('updateTaskDetails',payload);
              this.close();
              document.getElementById('close').click();
        },
        updateform(){
      this.checklistview=true;
    },
        async getuserdetails(id){
      var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${id}`,optionAxios)
                const data = response.data;
                return data.name;

    },
        async GetArray(id){
      var tem = new Array();
      for (let index = 0; index < id.length; index++) {
              const element = id[index];
             // alert(element)

              var optionAxios = {
          headers: {
                   'Accept': 'text/plain'
                  }                         }
          await  axios.get(`https://tmsapi.areteonline.in/api/users/${element}`,optionAxios)
              .then(function (res) {
                  // handle success
                  const data = res.data;
                tem.push(data.name);
              })
              .catch(function (error) {
                  // handle error
                  console.log(error);
              })
              .then(function () {
                  // always executed
                  console.log('--------s-')
              });

      }
      let nameed= tem.toString();
      this.Tskassignuser=nameed;

    },
        filter(){
      var arrR = this.fetchChecklist.filter(function(ele){
        return (ele.status == "true")
      });
      this.count=arrR.length;
    },
        async taskActivity(id){
    
    await this.$store.dispatch('getTaskdetailsUser',id);
    await this.$store.dispatch('getCheckListdetailsUser',id);
    await this.$store.dispatch('getActionListdata',id);
    await this.$store.dispatch('getCommentsListdata',id);
    
    this.edittasktitle=this.fetechUserTask.title;
    this.editdescription=this.fetechUserTask.description;
    var result =this.fetechUserTask.assign;
    
    var temp = new Array();
         temp.push(this.fetechUserTask.assign);
         console.log('temp',temp);
         
    let main=result;
    console.log([main]);
   this.GetArray(temp);

    this.taskprojectID=this.fetechUserTask.projectid;
    this.taskID=this.fetechUserTask.taskid;
    this.hod=await this.getuserdetails(this.fetechUserTask.userName);
    // this.editprojectName=this.fetchrowSubprojects.projectname;
    this.filter();

 
   },
        close() {
        this.$emit('close');
      },
        async submitTask(event){
         
               let s='';
                if(this.user){
                   s=this.user;
                }else{
                   s=localStorage.getItem('userID');
                }

               this.close();
               document.getElementById('close1').click();


               var optionAxios1 = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const responsed = await axios.get(`https://tmsapi.areteonline.in/api/projects/${this.Projectid}`,optionAxios1)
                const data1 = responsed.data;



          
              var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${s}`,optionAxios)
                const data = response.data;

            
              let sendmail={
              subject:'New Task Assign By '+localStorage.getItem('Username'),
              usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="150" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">Goal-Tracker</td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300"><p>You have a task due in Goal-Tracker.  <a href="https://tms.areteonline.in">Click here</a> </p>  <table style="font-family:arial,sans-serif;border-collapse:collapse;width:100%;border:1px solid #000"><thead><tr style="border:1px solid"><th style="border:1px solid">Date</th><th style="border:1px solid">Task</th></tr></thead><tbody><tr style="border:1px solid"><td style="border:1px solid" align="center" >'+this.moment(this.Duedate)+'</td><td style="border:1px solid" align="center" >'+this.title+'</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e"  height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
              username:data.name,
              useremail:data.email,
              }

              this.$store.dispatch('SendTaskAssign',sendmail);

          
            setTimeout(() => {

              let payload={
               projectid:this.Projectid,
               depart:localStorage.getItem('department'),
               sdate:this.Duedate,
               userName:localStorage.getItem('userID'),
               title:this.title,
               assign:s,
               progress:'todo',
               priority:this.Priority,
               position:this.Position,
               duedate:this.Duedate,
               entyid:data1.entyid,
               sprojectid:'',
               description:this.description,
            }


             console.log('-sdf---',payload);
             this.$store.dispatch('TaskInsert',payload);
             this.$store.dispatch('ActionUserWiseTaskList',localStorage.getItem('userID'));

             this.$swal({
                    text: 'Successfully Inserted record.',
                    target: '#custom-target',
                    customClass: {
                      container: 'position-absolute'
                    },
                    toast: true,
                    position: 'top'
                });

             event.target.reset();


              
            }, 500);   
            
            

        },
        async submitTask1(event){
          var result='';
          if(this.user){

             result = this.user.map(function(val) {
              return val;
            }).join(',');
          }else{ result ='';}

               let s='';
                if(result){
                   s=result;
                }else{
                   s=localStorage.getItem('userID');
                }

                const arr = s.split(',');

                console.log('results',arr);

              //  this.close();
              //  document.getElementById('close1').click();
               var temp = new Array();

            for (let index = 0; index < arr.length; index++) {
              const element = arr[index];

              var optionAxios = {
                  headers: {
                                  'Accept': 'text/plain'
                          }                         }
                const response = await axios.get(`https://tmsapi.areteonline.in/api/users/${element}`,optionAxios)
                const data = response.data;
                temp.push(data.userId);

            
              let sendmail={
              subject:'New Task Assign By '+localStorage.getItem('Username'),
              usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="150" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">Goal-Tracker</td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300"><p>You have a task due in Goal-Tracker.  <a href="https://tms.areteonline.in">Click here</a> </p>  <table style="font-family:arial,sans-serif;border-collapse:collapse;width:100%;border:1px solid #000"><thead><tr style="border:1px solid"><th style="border:1px solid">Date</th><th style="border:1px solid">Task</th></tr></thead><tbody><tr style="border:1px solid"><td style="border:1px solid" align="center" >'+this.Duedate+'</td><td style="border:1px solid" align="center" >'+this.title+'</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e"  height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
              username:data.name,
              useremail:data.email,
              }

              this.$store.dispatch('SendTaskAssign',sendmail);

              
            } 
            let nameed= temp.toString()
            console.log('temp',nameed);
      


            setTimeout(() => {

              let payload={
               projectid:this.Projectid,
               depart:localStorage.getItem('department'),
               sdate:this.Duedate,
               userName:localStorage.getItem('userID'),
               title:this.title,
               assign:nameed,
               progress:'todo',
               priority:this.Priority,
               position:this.Position,
               duedate:this.Duedate,
               entyid:'',
               sprojectid:'',
               description:this.description,
            }


             console.log('-sdf---',payload);
             this.$store.dispatch('TaskInsert',payload);

             this.$swal({
                    text: 'Successfully Inserted record.',
                    target: '#custom-target',
                    customClass: {
                      container: 'position-absolute'
                    },
                    toast: true,
                    position: 'top'
                });

             event.target.reset();

             this.$store.dispatch('GetTodoList',localStorage.getItem('userID'));
             this.$store.dispatch('GetInprogressList',localStorage.getItem('userID'));
             this.$store.dispatch('GetTestingList',localStorage.getItem('userID'));
             this.$store.dispatch('GetDoneList',localStorage.getItem('userID'));

              
            }, 500);   
            
            

        },

      //  async submitTask(event){
      //     var result='';
      //     if(this.user){

      //        result = this.user.map(function(val) {
      //         return val;
      //       }).join(',');
      //     }else{ result ='';}

      //          let s='';
      //           if(result){
      //              s=result;
      //           }else{
      //              s=localStorage.getItem('Username');
      //           }

      //     await this.$store.dispatch('getUserdata',s);

      //       setTimeout(() => {

      //        // let named=this.getTaskEmailUser.name;
      //         let email=this.getTaskEmailUser.email;

      //         let payload={
      //          projectid:this.Projectid,
      //          depart:localStorage.getItem('department'),
      //          sdate:this.Duedate,
      //          hod:localStorage.getItem('Username'),
      //           title:this.title,
      //           assign:s,
      //           progress:'todo',
      //           priority:this.Priority,
      //           position:this.Position,
      //           duedate:this.Duedate,
      //           entyid:'',
      //           sprojectid:''
      //       }
      //        console.log('-sdf---',payload);
      //        this.$store.dispatch('TaskInsert',payload);

      //       let sendmail={
      //         subject:'hello',
      //         usermessage:'<table width="100%" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td align="center" valign="top" bgcolor="#66809b" style="background-size:cover;background-position:top" 400><table class="col-600" width="600" height="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="40"></td></tr><tr><td align="center" style="line-height:0"><img style="display:block;line-height:0;font-size:0;border:0" src="https://tms.areteonline.in/img/logo1.png" width="300" height="150" alt="logo"></td></tr><tr><td align="center" style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:24px;font-weight:700;letter-spacing:7px">TMS<span style="font-family:Raleway,sans-serif;font-size:37px;color:#fff;line-height:39px;font-weight:300;letter-spacing:7px">Notification</span></td></tr><tr><td height="50"></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="margin-left:20px;margin-right:20px"><tbody><tr><td align="center"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="right"><table width="500" border="0" align="left" cellpadding="0" cellspacing="0" class="col2" style=""><tbody><tr><td align="center"><table class="insider" width="400" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr align="left"><td style="font-family:Raleway,sans-serif;font-size:23px;color:#2a3b4c;line-height:30px;font-weight:700">Task Assign</td></tr><tr><td height="5"></td></tr><tr><td style="font-family:Lato,sans-serif;font-size:14px;color:#7f8c8d;line-height:24px;font-weight:300">We create responsive websites with modern designs and features for small businesses and organizations that are professionally developed and SEO optimized.</td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td align="center"><table align="center" width="100%" border="0" cellspacing="0" cellpadding="0" style="border-left:1px solid #dbd9d9;border-right:1px solid #dbd9d9"><tbody><tr><td height="50"></td></tr><tr><td align="center" bgcolor="#34495e" background="https://designmodo.com/demo/emailtemplate/images/footer.jpg" height="185"><table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0"><tbody><tr><td height="25"></td></tr><tr><td height="25"></td></tr></tbody></table><table align="center" width="35%" border="0" cellspacing="0" cellpadding="0"></table></td></tr></tbody></table></td></tr></tbody></table></td></tr></tbody></table>',
      //         username:s,
      //         useremail:email,
      //       }

      //        this.$store.dispatch('SendTaskAssign',sendmail);
      //        event.target.reset();

              
      //       }, 500);    

           


      //   },
        departmentlist(){
           // this.$store.dispatch('DeptList');
            this.$store.dispatch('fetchUserType');
            this.$store.dispatch('fetchProjects',localStorage.getItem('userID'));
            this.$store.dispatch('GetUsers');
           // this.$store.dispatch('ActionEntity');
           // this.$store.dispatch('ActionSubProject');
            this.$store.dispatch('DepartUser',localStorage.getItem('department'));
            this.$store.dispatch('ActionUserWiseTaskList',localStorage.getItem('userID'));

        }
      }
    }
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
